import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { ExchangeRateModel } from '../../types/models/ExchangeRateModel';
import axios from "axios";
import { ApiRounded } from '@mui/icons-material';

interface ExchangeRateResponse{
  data: ExchangeRateModel[];
  totalCount: number;
}

interface ExchangeRateState {
  data: ExchangeRateModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

const initialState: ExchangeRateState = {
  data: [],
  totalRecords: 0,
  currentPage: 1,
  loading: false,
  error: null,
  status: null
};

const API_URL = '/ExchangeRate';

export const fetchER = createAsyncThunk<ExchangeRateResponse, {
  filters: Record<string, any>; 
  page: number; 
  numberOfRecord: number; 
  input:  ExchangeRateModel;
  sortColumn?: string;
  sortOrder?: 'asc' | 'desc';
  iscompanySubype : boolean;
  }>(
  'exchangeRateDivision/fetchExchangeRate',
  async ({ filters,page, numberOfRecord,input, sortColumn = '', sortOrder = 'asc',iscompanySubype}) => {
    
    try {
        const searchUnit =  filters.search || "";
        const safeSortColumn = sortColumn ?? '';
        const response = await nexapi.post(API_URL + `/GetExchangeRate?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&search=${searchUnit}&sortColumn=${safeSortColumn}&sortOrder=${sortOrder}&state=${filters.state}&userTimeZone=${filters.userTimeZone}&isCompanyER=${iscompanySubype}`,input);

      const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          data: data.data,
          totalCount: data.totalCount, 
        };
      } else {
        console.error('Invalid API Response:', data);
        return { data: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);


export const deleteApplication = createAsyncThunk<ExchangeRateResponse, { Id : string, UserId:string,reason: string}>(
    'exchangeRateDivision/deactivateActivate',

    async ({ Id,UserId,reason}) => {
      
     
      try {
          
          
        const [cleanId] = Id.includes('_') ? Id.split('_') : [Id];

        const payload = {
          Id: cleanId,
          UserId: UserId,
          reason: reason
        };
        const url = API_URL+"/ActivateDeactivate";
        const method = "post";
        const response = await nexapi[method](url, payload);

        
        
      return response.data;
      } catch (error) {
        console.error('API Call Failed:', error);
        throw error;
      }
    }
  );
  

const exchangaRateSlice = createSlice({
  name: 'exchangeRateDivision',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchER.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchER.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.status = 'succeeded';
      })
      .addCase(fetchER.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch division';
      })
      .addCase(deleteApplication.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.status = 'succeeded';
      })
      .addCase(deleteApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch division';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default exchangaRateSlice.reducer;